// for web (which doesn't use splash screen) / make typescript happy
export const AnimatedSplashScreen = {
  hide: async () => Promise.resolve(),
  getHideSplashPreInit: () => true,
};
